export enum StepEnum {
  SELECT_OPTIONS = 'SELECT_OPTIONS',
  SELECT_MENU = 'SELECT_MENU',
  SELECT_EXTRA = 'SELECT_EXTRA',
  SELECT_CLIENT_REQUEST = 'SELECT_CLIENT_REQUEST',
}

export enum MODAL_SELECT_PROPOSAL_MODE {
  IN_HOUSE_CARD = 'IN_HOUSE_CARD',
  DEFAULT = 'DEFAULT',
}
